import classNames from 'classnames';
import { Stack } from '@servicetitan/design-system';
import { Logo } from './logo';
import { Navigation } from '../navigation/navigation';

import * as Styles from './header.module.less';

export const Header = () => {
    return (
        <Stack
            className={classNames('bg-neutral-300 position-relative', Styles.header)}
            alignItems="center"
            justifyContent="space-between"
        >
            <Logo />
            <Stack className="position-absolute w-100 h-100" justifyContent="center">
                <Navigation />
            </Stack>
        </Stack>
    );
};
